import {DocumentSection, DocumentSectionExcerpt} from '@/engine';

export const getAnalyticsDocumentSectionPageName = ({id, trackingId}: DocumentSection | DocumentSectionExcerpt) =>
  `${id.toLowerCase()}-${trackingId}`;
